import { Group, MultiSelect, type MultiSelectProps } from "@mantine/core"
import { useUsers } from "@/hooks"
import { filterUser, prepareQuery } from "@/utils"
import { UserAvatar } from "../people"

interface IProps extends MultiSelectProps {
  exclude?: string[]
}

export function UsersSelect({ value, exclude = [], ...props }: IProps) {
  const { users } = useUsers()
  const data = users
    .filter((u) => !exclude.includes(u.id))
    .map((user) => ({
      value: user.id,
      label: user.full_name || user.name,

      email: user.email,
      picture: user.picture,
      position: user.position,
      full_name: user.full_name,
    }))

  return (
    <MultiSelect
      searchable
      hidePickedOptions
      renderOption={Option}
      comboboxProps={{ withinPortal: true }}
      filter={({ options, search }) => {
        const query = prepareQuery(search)
        return options.filter((item) => filterUser(query, item as any))
      }}
      value={value ?? []}
      {...props}
      data={data}
    />
  )
}

function Option({ option }) {
  return (
    <Group wrap="nowrap" gap="xs">
      <UserAvatar user={option} size={24} />
      {option.full_name}
    </Group>
  )
}
